/**
 * Parse a single SSE event block ("event: <type>\ndata: <payload>") into
 * { eventType, payload }. Returns null when the block has no data line.
 *
 * Hardened (LOCAL-DEV-WIRING-CLEANUP Lane D):
 * - Splits on /\r?\n/ so a server using CRLF line endings doesn't leave a
 *   trailing \r on each field (which would corrupt the JSON payload).
 * - Accepts both "field: value" and "field:value" (SSE spec allows no space
 *   after the colon) — strips a single optional leading space.
 *
 * Sibling to ISS-388 (the SSE chunk-split citation drop); this is a different,
 * smaller line-level hardening — the chunk-buffering fix lives in BoltChat.jsx.
 */
export const parseSSEBlock = (rawEvent) => {
  const lines = rawEvent.split(/\r?\n/);
  let eventType = null;
  const dataLines = [];
  for (const line of lines) {
    if (line.startsWith('event:')) {
      eventType = line.slice(6).replace(/^ /, '').trim();
    } else if (line.startsWith('data:')) {
      dataLines.push(line.slice(5).replace(/^ /, ''));
    }
  }
  if (dataLines.length === 0) return null;
  return { eventType, payload: dataLines.join('\n') };
};
